// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Btn from "../../html/Btn.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Date from "../../../util/Date.js";
import * as Buhta_cabinet__Dropdowns from "../../molecules/Dropdowns.js";
import * as Buhta_cabinet__Field from "../../html/Field.js";
import * as Buhta_cabinet__FieldNumber from "../../../util/FieldNumber.js";
import * as Buhta_cabinet__RadioButton from "../../html/RadioButton.js";
import * as Buhta_cabinet__TaxControl from "../../../grpc/TaxControl.js";
import * as Buhta_cabinet__ToastSender from "../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function OrgSettingsTaxes(Props) {
  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match[1];
  const match$1 = React.useState(function () {
    return "";
  });
  const setRegistrationDate = match$1[1];
  const registrationDate = match$1[0];
  const match$2 = React.useState(function () {
    return /* TAX_MODE_UNSPECIFIED */ 0;
  });
  const setTaxMode = match$2[1];
  const taxMode = match$2[0];
  const match$3 = React.useState(function () {
    return "";
  });
  const setTaxModeError = match$3[1];
  const match$4 = React.useState(function () {
    return "";
  });
  const setKogd = match$4[1];
  const kogd = match$4[0];
  const match$5 = React.useState(function () {
    return "";
  });
  const setKogdLiving = match$5[1];
  const kogdLiving = match$5[0];
  const match$6 = React.useState(function () {
    return false;
  });
  const setHasVat = match$6[1];
  const hasVat = match$6[0];
  const match$7 = React.useState(function () {
    return Buhta_cabinet__FieldNumber.empty;
  });
  const setVatPercent = match$7[1];
  const vatPercent = match$7[0];
  const match$8 = React.useState(function () {
    return "";
  });
  const setVatCertSeries = match$8[1];
  const vatCertSeries = match$8[0];
  const match$9 = React.useState(function () {
    return "";
  });
  const setVatCertNumber = match$9[1];
  const vatCertNumber = match$9[0];
  const match$10 = React.useState(function () {
    return "";
  });
  const setVatCertIssueDate = match$10[1];
  const vatCertIssueDate = match$10[0];
  const match$11 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$11[0];
  const func = Buhta_cabinet__TaxControl.TaxInformationService.view;
  const match$12 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._2(func, param, /* [] */ 0);
  }), undefined);
  const dispatch = match$12[1];
  const settings = match$12[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), []);
  React.useEffect((function () {
    if (typeof settings !== "string" && settings.NAME === "Data") {
      const settings$1 = settings.VAL;
      Curry._1(setTaxMode, (function (param) {
        return settings$1.mode;
      }));
      Curry._1(setKogd, (function (param) {
        return settings$1.kogd;
      }));
      const vat = settings$1.vat;
      if (vat !== undefined) {
        Curry._1(setHasVat, (function (param) {
          return true;
        }));
        Curry._1(setVatCertNumber, (function (param) {
          return vat.cert_number;
        }));
        Curry._1(setVatCertSeries, (function (param) {
          return vat.cert_series;
        }));
        Buhta_cabinet__FieldNumber.set(setVatPercent, vat.percent);
        Belt__Belt_Option.forEach(vat.cert_issue_date, (function (date) {
          Curry._1(setVatCertIssueDate, (function (param) {
            return Buhta_cabinet__Date.toString(date);
          }));
        }));
      } else {
        Curry._1(setHasVat, (function (param) {
          return false;
        }));
      }
      Belt__Belt_Option.forEach(settings$1.register_date, (function (date) {
        Curry._1(setRegistrationDate, (function (param) {
          return Buhta_cabinet__Date.toString(date);
        }));
      }));
      Belt__Belt_Option.forEach(settings$1.kogd_living, (function (kogd) {
        Curry._1(setKogdLiving, (function (param) {
          return kogd;
        }));
      }));
    }
    
  }), [settings]);
  const saveSettings = function (ev) {
    ev.preventDefault();
    if (taxMode === /* TAX_MODE_UNSPECIFIED */ 0) {
      return Curry._1(setTaxModeError, (function (param) {
        return "Поле обязательно";
      }));
    }
    let tmp;
    if (hasVat) {
      const value = vatPercent.value;
      tmp = {
        cert_series: vatCertSeries,
        cert_number: vatCertNumber,
        cert_issue_date: vatCertIssueDate === "" ? undefined : Buhta_cabinet__Date.fromString(vatCertIssueDate),
        percent: value !== undefined ? Stdlib.string_of_float(value) : ""
      };
    } else {
      tmp = undefined;
    }
    const settingsForm_register_date = registrationDate === "" ? undefined : Buhta_cabinet__Date.fromString(registrationDate);
    const settingsForm_kogd_living = kogdLiving === "" ? undefined : kogdLiving;
    const settingsForm = {
      id: "",
      mode: taxMode,
      register_date: settingsForm_register_date,
      kogd: kogd,
      kogd_living: settingsForm_kogd_living,
      vat: tmp,
      create_time: undefined,
      update_time: undefined
    };
    const __x = Buhta_cabinet__TaxControl.TaxInformationService.update(tenant, settingsForm);
    $$Promise.get(__x, (function (result) {
      if (result.TAG === /* Ok */ 0) {
        return Curry._1(dispatchToasts, {
          TAG: /* Add */ 0,
          _0: {
            id: Buhta_core__Toast.generateId(undefined),
            text: "Настройки сохранены",
            kind: "success",
            onClick: (function (param) {
              
            })
          }
        });
      } else {
        return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при сохранении");
      }
    }));
  };
  return JsxRuntime.jsx("form", {
    children: typeof settings === "string" || settings.NAME !== "Data" ? null : JsxRuntime.jsxs(React.Fragment, {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                value: registrationDate,
                onPicked: (function (date) {
                  Curry._1(setRegistrationDate, (function (param) {
                    return DateTime.toDateFormat(date);
                  }));
                }),
                align: "BottomRight",
                label: "Дата регистрации предприятия"
              }),
              JsxRuntime.jsx(Buhta_cabinet__Dropdowns.TaxModeSelect.make, {
                taxMode: taxMode,
                onTaxModeSelect: (function (value) {
                  Curry._1(setTaxMode, (function (state) {
                    return value;
                  }));
                  Curry._1(setTaxModeError, (function (param) {
                    return "";
                  }));
                }),
                error: match$3[0]
              }),
              JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                className: "text-default-gray mt-6",
                children: "Код органа гос. доходов"
              }),
              JsxRuntime.jsx(Buhta_cabinet__Dropdowns.KogdSelect.make, {
                kogd: kogd,
                onKogdSelect: (function (value) {
                  Curry._1(setKogd, (function (param) {
                    return value;
                  }));
                }),
                label: "По месту нахождения"
              }),
              JsxRuntime.jsx(Buhta_cabinet__Dropdowns.KogdSelect.make, {
                kogd: kogdLiving,
                onKogdSelect: (function (value) {
                  Curry._1(setKogdLiving, (function (param) {
                    return value;
                  }));
                }),
                label: "По месту жительства"
              }),
              JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                className: "text-default-gray mt-6",
                children: "НДС"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                    checked: !hasVat,
                    onChange: (function (param) {
                      Curry._1(setHasVat, (function (param) {
                        return false;
                      }));
                    }),
                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: "ml-2",
                      children: "Без НДС"
                    })
                  }),
                  JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                    checked: hasVat,
                    onChange: (function (param) {
                      Curry._1(setHasVat, (function (param) {
                        return true;
                      }));
                    }),
                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: "ml-2",
                      children: "С НДС"
                    })
                  })
                ],
                className: "flex gap-6 mt-3 items-center"
              }),
              hasVat ? JsxRuntime.jsxs(React.Fragment, {
                  children: [
                    JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                          label: "Серия",
                          size: "m",
                          required: true,
                          onChange: (function (value) {
                            Curry._1(setVatCertSeries, (function (param) {
                              return value;
                            }));
                          }),
                          className: "mt-4",
                          value: vatCertSeries
                        }),
                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                          label: "Номер",
                          size: "m",
                          required: true,
                          onChange: (function (value) {
                            Curry._1(setVatCertNumber, (function (param) {
                              return value;
                            }));
                          }),
                          className: "mt-4",
                          value: vatCertNumber
                        })
                      ],
                      className: "flex gap-4"
                    }),
                    JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                      value: vatCertIssueDate,
                      onPicked: (function (date) {
                        Curry._1(setVatCertIssueDate, (function (param) {
                          return DateTime.toDateFormat(date);
                        }));
                      }),
                      className: "mt-4",
                      label: "Дата выдачи"
                    }),
                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                      label: "Ставка",
                      size: "m",
                      required: true,
                      onChange: (function (value) {
                        Buhta_cabinet__FieldNumber.set(setVatPercent, value);
                      }),
                      className: "mt-4",
                      value: vatPercent.text
                    })
                  ]
                }) : null
            ],
            className: "bg-white w-[562px] rounded-md shadow-kkm p-10"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
              title: "Продолжить",
              className: "px-6 py-3",
              type_: "submit"
            }),
            className: "w-[562px] flex justify-end mt-6"
          })
        ]
      }),
    className: "flex flex-col items-center py-6",
    onSubmit: saveSettings
  });
}

const make = OrgSettingsTaxes;

export {
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
